module.exports = __webpack_public_path__ + "img/kuaishou4s.53d4fcd6.png";